import { render } from "./TopBar.vue?vue&type=template&id=aae1c97c&scoped=true"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"

import "./TopBar.vue?vue&type=style&index=0&id=aae1c97c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aae1c97c"]])

export default __exports__